export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            inputValue: '',
        };
    },
    watch: {
        value(newValue: any) {
            (<any>this).inputValue = newValue;
        }
    },
    methods: {
        onInput(e: any) {
            const value = e.target.value ? e.target.value.trim() : e.target.value;
            const self = <any>this;
            self.isDirty = true;
            self.inputValue = value;
            self.$emit('input', value);
            self.$emit('valueChanged', value, self.name);
        },
        onBlur() {
            const self = <any>this;
            self.$emit('blur', self.name, self.inputValue, self.isDirty);
        },
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/components/forms/BaseInput.ts